import { render, staticRenderFns } from "./ModalEditar.vue?vue&type=template&id=d1c85084"
import script from "./ModalEditar.vue?vue&type=script&lang=js"
export * from "./ModalEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports